import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionQuotationStateForm_UpdateQuotationInfoState_Mutation =
  graphql(`
    mutation MissionQuotationStateForm_UpdateQuotationInfoState(
      $actionId: Id!
      $missionId: Id!
      $selectedOptionGroupIds: [Id!]
      $templateId: Id
      $title: NonEmptyString
      $versionData: VersionDataInput
    ) {
      updateQuotationInfoState(
        actionId: $actionId
        missionId: $missionId
        selectedOptionGroupIds: $selectedOptionGroupIds
        templateId: $templateId
        title: $title
        versionData: $versionData
      ) {
        _id
        quotationInfo {
          stateId
        }
      }
    }
  `);

export type MissionQuotationStateForm_UpdateQuotationInfoState_Result =
  ResultOf<typeof MissionQuotationStateForm_UpdateQuotationInfoState_Mutation>;

export const useUpdateMissionQuotationInfoStateMutation = () =>
  useGraphQLMutation(
    MissionQuotationStateForm_UpdateQuotationInfoState_Mutation,
  );
